export default __webpack_public_path__ + "static/Graphik-RegularItalic-Web-bfecca8c921babd3d5f966572be2536b.ttf";